import { call, put, takeEvery } from 'redux-saga/effects';
import {
    setIsErrorLeadConversation,
    setIsLoadingLeadConversation,
    setIsSuccessLeadConversation,
} from '../actions/get_lead_conversation.actions';
import { getLeadProfileConversation } from '../../requests/get_lead_profile_request';
import {GET_LEAD_CONVERSATION} from '../constants/get_lead_conversation.constants';

export function* getLeadConversation(ref_lead) {
    yield put(setIsLoadingLeadConversation(true));

    try {
        const conversations = yield call(getLeadProfileConversation, ref_lead);

        yield put(setIsSuccessLeadConversation(conversations?.options));
        yield put(setIsLoadingLeadConversation(false));
    } catch (error) {
        yield put(setIsErrorLeadConversation(error));
        yield put(setIsLoadingLeadConversation(false));
    }
}

export function* getLeadConversationSaga() {
    yield takeEvery(GET_LEAD_CONVERSATION, getLeadConversation);
}


// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/get_lead_conversation.saga.js